var _g, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconHome(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 964,
    height: 1024,
    viewBox: "0 0 964 1024",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icomoon-ignore"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M867.388 337.201c12.047 8.023 16.059 20.056 16.059 32.089v441.224c0 68.186-52.2 120.332-120.471 120.332h-562.193c-68.266 0-120.471-52.146-120.471-120.332v-441.224c0-12.033 4.016-24.066 16.063-32.089l361.412-280.779c12.047-12.033 32.125-12.033 48.188 0l361.413 280.779zM562.195 529.735h-160.627v320.89h160.627v-320.89zM762.976 850.625c24.094 0 40.159-16.041 40.159-40.111v-421.168l-321.254-248.69-321.255 248.69v421.168c0 24.070 16.062 40.111 40.156 40.111h120.471v-361.001c0-24.066 16.063-40.111 40.157-40.111h240.941c24.095 0 40.154 16.045 40.154 40.111v361.001h120.471z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHome);
export default __webpack_public_path__ + "static/media/icon-home.a18b6425746ed53733681b34336b3ffe.svg";
export { ForwardRef as ReactComponent };